import NotificationDisplay from './notification-display';

export default NotificationDisplay;
